<template>
  <fragment>
    <collapsed-card
      collapse-key="exchange"
      title-text="Ideal Career Opportunities"
    >
      <job-profiles-list>
        <span
          slot="empty-list-text"
          class="v2_font_size_20  v2_color_black"
        >
          You have not created an ICO yet. Create one by clicking the ‘Create
          ICO’ button above or go to the
          <router-link to="/exchange">Connect</router-link> for more
          information.
        </span>
      </job-profiles-list>
    </collapsed-card>
  </fragment>
</template>

<script>
import JobProfilesList from '@/components/exchange/job-profiles-list/JobProfilesList';

export default {
  name: 'JobProfilesSection',
  components: {
    JobProfilesList,
  },
};
</script>

<style scoped />
